export default "__VITE_ASSET__BnM3b3P4__"